import { styled } from "@mui/material/styles";
import { TableCell } from "@mui/material";

export const StyledTableCell = styled(TableCell)`
  white-space: nowrap;
  width: 100%;

  cursor: ${({ columnId }) =>
    columnId !== "category" &&
    columnId !== "edit" &&
    columnId !== "delete" &&
    columnId !== "signatureId"
      ? "pointer"
      : "default"};

  > div {
    display: flex;
    align-items: center;
    gap: 5px;

    > div {
      width: 60px;
    }
  }
`;
